<template>
  <div>
    <div class='' >
      <div class = "listBox" >
        <span v-if = "list.children&&list.children.length" style = 'display:inline-block;vertical-align:middle;' @click = '_goup()'>
          <Icon v-if = "list.expand" type="ios-arrow-down" />
          <Icon v-else type="ios-arrow-forward" />
        </span>
        <span class = 'tree-title'>
          <Checkbox v-model="list.checked" :disabled = "list.isEdit" @on-change="_select(list)"></Checkbox>
          <Tooltip placement="top" :content="list.title" :delay="1000">
            <span class = 'title-content'>{{list.title|treetitle}}</span>
          </Tooltip>
        </span>
      </div>
      <div v-show = 'list.expand&&list.children&&list.children.length' style = "padding-left:20px;">
        <MyTreeNode @select = '_select'  :checkedIndex = 'checkedIndex' :dataKey = 'dataKey' :key = 'index' v-for = '(item,index) in list.child' :list = 'item' />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MyTreeNode',
  props: {
    list: {},
    dataKey: 'title',
    checkedIndex: ''
  },
  data(){
    return {
    }
  },
  methods:{
    _select(item){
      console.log('change==',item)
      this.$emit('select',item)
    },
    _goup(){
      this.list.expand = !this.list.expand
      if(this.list.child&&!this.list.child.length&&this.list.children&&this.list.children.length){
        this.list.child = this.list.children
      }
    },
    _deleteSuccess(item){
      let {parent} = item
      if(parent&&parent.children&&parent.children.length){
        for(let i in parent.children){
          if(item[this.dataKey] == parent.children[i][this.dataKey]){
            parent.children.splice(i,1)
            return
          }
        }
      }
    }
  },
  filters: {
    treetitle(str){
      if(str&&str.length<=8){
        return str
      }else if(str&&str.length>8){
        return str.substr(0,8)+'...'
      }
      return str
    }
  },
  components: {}
}
</script>
<style scoped lange = "less">
.item_checked{
  background: #e8f7f8;
  color: #00b8c4;
}
.handlBox{
  display: none;
}
.listBox{
  cursor:pointer;
  max-width: 218px;
  height:30px;
  line-height:30px;
  padding:0 5px;
}
.listBox:hover .handlBox{
  display: inline-block;
}
.listBox:hover{
  background: #e8f7f8;
}
.tree-title{
  padding-left:5px;
}

</style>